import {
  assign, head, set, isObject,
} from 'lodash';
import {
  configApi, roundApi, ticketApi, jackpotApi,
} from '@/api';
import types from './mutationTypes';

export default {
  downloadFile(context, payload) {
    const fileURL = window.URL.createObjectURL(new Blob([payload]));
    const fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', 'tickets.csv');
    document.body.appendChild(fileLink);
    fileLink.click();
    fileLink.remove();
  },
  loadConfig({ commit, getters }, payload) {
    return configApi.getConfig(payload).then((result) => {
      commit(types.SET_TRANSLATIONS, result.translations);
      commit(types.SET_CONFIG, assign(result, {
        timezoneOffset: payload.timezoneOffset,
      }));

      return getters.config;
    });
  },
  loadRounds({ commit, getters }, payload) {
    const { userTimezoneOffset } = getters;
    return roundApi.getRounds(payload).then((result) => {
      commit(types.SET_ROUNDS, {
        items: result.rounds,
        timezoneOffset: userTimezoneOffset,
        totals: result.totals,
      });
      commit(types.SET_PAGINATION, result.pagination);
      return result;
    });
  },
  loadJackpots({ commit, getters }, payload) {
    const { userTimezoneOffset } = getters;
    return jackpotApi.getJackpots(payload).then((result) => {
      commit(types.SET_JACKPOTS, {
        items: result.jackpotWinnings,
        timezoneOffset: userTimezoneOffset,
        totals: result.totals,
      });
      commit(types.SET_PAGINATION, result.pagination);
      return result;
    });
  },
  loadTicketFilters({ commit }, payload) {
    return ticketApi.getTicketFilters(payload).then((result) => {
      commit(types.SET_TICKET_FILTERS, result);
      return result;
    });
  },
  loadTickets({ commit, dispatch, getters }, payload) {
    const { userTimezoneOffset } = getters;
    return ticketApi.getTickets(payload).then((result) => {
      if (isObject(result)) {
        commit(types.SET_TICKETS, {
          items: result.tickets,
          timezoneOffset: userTimezoneOffset,
          totals: result.totals,
        });
        commit(types.SET_PAGINATION, result.pagination);
      } else {
        dispatch('downloadFile', result);
        dispatch('setExportType', null);
      }
      return result;
    });
  },
  loadTicketBets({ commit, getters }, payload) {
    const { tickets } = getters;
    if (tickets.length && !payload.ticketId) {
      const ticket = head(tickets);
      set(payload, 'ticketId', ticket.id);
    }
    return ticketApi.getTicketBets(payload).then((result) => {
      commit(types.SET_TICKET_BETS, {
        tickets,
        ticketId: payload.ticketId,
        ticketBets: result,
      });
    });
  },
  resetFilters({ commit }) {
    commit(types.RESET_FILTERS);
  },
  resetTicketsFilters({ commit }) {
    commit(types.RESET_TICKET_FILTERS);
  },
  setFilters({ commit }, payload) {
    commit(types.SET_FILTERS, payload);
  },
  setPlatform({ commit }, payload) {
    commit(types.SET_PLATFORM, payload);
  },
  setUser({ commit }, payload) {
    commit(types.SET_USER, payload);
  },
  setToken({ commit }, payload) {
    commit(types.SET_USER_TOKEN, payload);
  },
  setChannel({ commit }, payload) {
    commit(types.SET_CHANNEL, payload);
  },
  setExportType({ commit }, payload) {
    commit(types.SET_EXPORT_TYPE, payload);
  },
  setInfoMessage({ commit }, payload) {
    commit(types.SET_INFO_MESSAGE, payload);
  },
  updateConfig({ commit }, payload) {
    commit(types.UPDATE_CONFIG, payload);
  },
};
